import { XIcon } from '@heroicons/react/solid';

export interface IFilterBadge {
  [key: string]: {
    label: string;
    value: string | number;
  };
}

interface IFilterBadgesListProps {
  displayFilters: IFilterBadge;
  handleRemoveFilter: (key: string) => void;
}

export const FilterBadgesList = ({
  displayFilters,
  handleRemoveFilter,
}: IFilterBadgesListProps) => {
  return (
    <dl
      id='filter-badges-list'
      className='flex flex-row flex-wrap gap-2 items-center'
    >
      {Object.keys(displayFilters).map((key: string) => {
        return (
          <div
            key={key}
            className='rounded bg-primaryColor-normal text-white py-1 px-2 text-xs font-semibold flex gap-2 items-center'
          >
            <dt>
              <span className='capitalize'>{displayFilters[key]?.label}: </span>
              <span className='capitalize'>{displayFilters[key]?.value}</span>
            </dt>
            <dd
              className='cursor-pointer rounded-full hover:text-primaryColor-medium'
              onClick={() => handleRemoveFilter(key)}
            >
              <XIcon className='h-4 w-4' />
            </dd>
          </div>
        );
      })}
    </dl>
  );
};
